import template   from './edit-vehicle.html'
import controller from './edit-vehicle.controller'
import './edit-vehicle.styl'

let component = {
  restrict: 'E',
  bindings: {
    vehicle: '<',
    onConfirm: '&'
  },
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-garage/components/edit-vehicle/edit-vehicle.component.js